define((require) => {
    "use strict";

    const {defaults}          = require("underscore");
    const {isBlank}           = require("shared/util/StringUtils");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");

    const DEFAULT_TEXT = "Your text here...";

    /**
     * Model for a text widget.
     *
     * @class TextWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Text widget", {

        transient: AbstractWidgetModel.prototype.transient.concat(["editorModel"]),

        defaults: defaults({
            type: "text",
            text: DEFAULT_TEXT,
            isDynamic: false,
            fontProvider: "standard",
            fontMetadata: {},
            fontSize: 30,
            fontStyle: "normal",
            color: "#000000",
            // Font family for the text widget container
            fontFamily: "Arial",
            lineHeight: 1.4,
            textAlign: "left",
            fontWeight: "400",
            textDecoration: "none",
            textTransform: "none",
            fontVariant: "none",
            textShadow: "none",

            // Contains all parsed font families for the whole text content, which covers nested font families
            fontFamilies: [],

            // Used to temperately store properties that needs to interact with the CharacterPropertyView
            editorModel: null,

            letterSpacing: 0
        }, AbstractWidgetModel.prototype.defaults),

        constructor(attributes) {
            this.preserveProperties(attributes);
            this.__super();
        },

        hasText() {
            return this.get("text") && this.get("text") !== DEFAULT_TEXT;
        },

        isValid() {
            // We need the text string to make sense
            return !isBlank(this.get("text"));
        },

        getScaledSize(scaleX) {
            const size = AbstractWidgetModel.prototype.getScaledSize.call(this, scaleX);
            // We want to limit the minimum width to 1%
            size.width = Math.max(1, size.width);

            return size;
        },

        /**
         * Preserve the properties for the compatibility check in the view layer. If we don't do this, the raw response
         * data will be merged with default properties, which may end up corrupt data like font family(google font)
         * mismatching font provider(standard).
         *
         * @See {@link TextWidgetView.onRender calls font compatibility check}
         * @param {Object} attrs
         */
        preserveProperties(attrs) {
            if (attrs.fontFamily) {
                if (!attrs.fontProvider) {
                    attrs.fontProvider = null;
                }

                if (!attrs.fontMetadata) {
                    attrs.fontMetadata = {};
                }

                if (!attrs.fontFamilies) {
                    attrs.fontFamilies = [];
                }
            }

            if (!attrs.fontWeight) {
                attrs.fontWeight = null;
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/textWidget/TextWidgetModel.js